// =============================================================================
// US-CUSTOM-02 -- Household colour palette
// =============================================================================
//
// Four built-in palettes on top of the existing light/dark toggle.
// Palette choice is persisted in localStorage so it survives page reloads.
// The key is scoped to the active account, so each family member can choose
// their own palette on a shared device.
//
// Drives a `data-palette` attribute on <html>. CSS overrides
// in styles/themes.css redefine the accent-colour design tokens for
// each palette.
//
// Available palettes:
//   default -- ChorePop blue, green, coral, and gold
//   ocean   -- blue/cyan
//   forest  -- green/amber
//   sunset  -- orange/pink

import { createSignal } from 'solid-js';
import { appearanceStorageKey, registerAppearanceLoader } from './accountAppearance';

export type Palette = 'default' | 'ocean' | 'forest' | 'sunset';

export const PALETTES: { id: Palette; label: string; preview: string }[] = [
  { id: 'default', label: 'ChorePop', preview: '#2d8fe5' },
  { id: 'ocean', label: 'Ocean', preview: '#0369a1' },
  { id: 'forest', label: 'Forest', preview: '#15803d' },
  { id: 'sunset', label: 'Sunset', preview: '#ea580c' },
];

function loadFromStorage(): Palette {
  try {
    const key = appearanceStorageKey('palette');
    const v = key === null ? null : localStorage.getItem(key);
    if (v === 'ocean' || v === 'forest' || v === 'sunset') return v;
  } catch {
    /* localStorage unavailable */
  }
  return 'default';
}

const [palette, SetPalette] = createSignal<Palette>('default');
registerAppearanceLoader(() => SetPalette(loadFromStorage()));

export function setPalette(p: Palette): void {
  SetPalette(p);
  try {
    const key = appearanceStorageKey('palette');
    if (key !== null) localStorage.setItem(key, p);
  } catch {
    /* ignore */
  }
}

export { palette };
